module.exports = __webpack_public_path__ + "static/media/paytm.c6d54e16.svg";